// extracted by mini-css-extract-plugin
export default {"tocWrapper":"style-module--tocWrapper--a7b2e","open":"style-module--open--def81","bigHeader":"style-module--bigHeader--7e17d","hasTopBar":"style-module--hasTopBar--9c4ae"};